
import { SET_WELCOME_MESSAGE_MODAL } from "./messageTypes";

export const setMessageModal = (data) => {
    return {
        type: SET_WELCOME_MESSAGE_MODAL,
        data: data
    }
}
